"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader } from "lucide-react";
export default function UnaprijediteSvojuTvrtku() {
  return <section id="unaprijedite-svoju-tvrtku" className="dark bg-background text-foreground py-24 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    
                    {}
                    <div>
                        <h2 className="font-default text-3xl md:text-4xl font-bold text-[#011466] mb-4 leading-tight">
                            Unaprijedite svoju tvrtku
                        </h2>
                        <p className="text-slate-600 mb-8 text-lg">
                            Zatražite demo i saznajte kako Mobileo može transformirati vaše poslovanje, uštedjeti vrijeme i povećati produktivnost.
                        </p>

                        <FormProvider formId="upgrade_form_home" sectionName="unaprijedite-svoju-tvrtku" defaultValues={{
            name: "",
            email: "",
            company_name: "",
            phone: "",
            message: ""
          }} validationRules={{
            name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            company_name: {
              required: true
            }
          }} submitText="Zatražite demo" successMessage="Hvala vam! Vaš zahtjev je uspješno poslan. Uskoro ćemo vas kontaktirati.">
                            <UpgradeForm />
                        </FormProvider>
                    </div>

                    {}
                    <div className="relative h-full flex items-center justify-center">
                        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/mobileo_dashboard_laptop_mockup.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/mobileo_dashboard_laptop_mockup.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/mobileo_dashboard_laptop_mockup.png-wvc-sizes" alt="Mobileo Dashboard na laptopu" className="w-full h-auto rounded-xl shadow-lg object-cover" loading="lazy" />
                    </div>
                </div>
            </div>
        </section>;
}
function UpgradeForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-green-50 border border-green-200 rounded-xl">
                <p className="text-green-800 font-medium">{successMessage}</p>
                <Button onClick={resetForm} variant="outline" className="mt-4 border-green-200 text-green-800 hover:bg-green-100">
                    Pošaljite novi zahtjev
                </Button>
            </div>;
  }
  return <Form onSubmit={handleSubmit}>
            <div className="space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <FormField control={control} name="name" rules={{
          required: "Ime i prezime je obavezno"
        }} render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-slate-700 font-medium">Ime i prezime *</FormLabel>
                                <FormControl>
                                    <Input placeholder="Marko Horvat" className="bg-slate-50 border-slate-200 text-slate-900 focus-visible:ring-[#022CE6]" {...field} />
                                </FormControl>
                                <FormMessage className="text-red-500 text-xs" />
                            </FormItem>} />
                    <FormField control={control} name="email" rules={{
          required: "E-mail adresa je obavezna",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Neispravna e-mail adresa"
          }
        }} render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-slate-700 font-medium">E-mail adresa *</FormLabel>
                                <FormControl>
                                    <Input type="email" placeholder="marko@example.com" className="bg-slate-50 border-slate-200 text-slate-900 focus-visible:ring-[#022CE6]" {...field} />
                                </FormControl>
                                <FormMessage className="text-red-500 text-xs" />
                            </FormItem>} />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <FormField control={control} name="company_name" rules={{
          required: "Naziv tvrtke je obavezan"
        }} render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-slate-700 font-medium">Naziv tvrtke *</FormLabel>
                                <FormControl>
                                    <Input placeholder="ABC d.o.o." className="bg-slate-50 border-slate-200 text-slate-900 focus-visible:ring-[#022CE6]" {...field} />
                                </FormControl>
                                <FormMessage className="text-red-500 text-xs" />
                            </FormItem>} />
                    <FormField control={control} name="phone" render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-slate-700 font-medium">Telefon</FormLabel>
                                <FormControl>
                                    <Input type="tel" placeholder="+385 91 123 4567" className="bg-slate-50 border-slate-200 text-slate-900 focus-visible:ring-[#022CE6]" {...field} />
                                </FormControl>
                                <FormMessage className="text-red-500 text-xs" />
                            </FormItem>} />
                </div>

                <FormField control={control} name="message" render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-slate-700 font-medium">Kratka poruka</FormLabel>
                            <FormControl>
                                <textarea placeholder="Recite nam u čemu možemo pomoći..." className="flex min-h-[100px] w-full rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-900 shadow-sm placeholder:text-slate-400 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#022CE6] disabled:cursor-not-allowed disabled:opacity-50" {...field} />
                            </FormControl>
                            <FormMessage className="text-red-500 text-xs" />
                        </FormItem>} />

                {submitError && <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                        <p className="text-red-800 text-sm">{submitError}</p>
                    </div>}

                <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto bg-[#022CE6] hover:bg-[#011466] text-white rounded-xl px-8 py-6 text-lg font-semibold transition-all">
                    {isSubmitting ? <>
                            <Loader className="animate-spin mr-2 size-5" />
                            Slanje...
                        </> : 'Zatražite demo'}
                </Button>
            </div>
        </Form>;
}